import axios from 'axios';
import { cloneDeep } from "lodash";

const FileDownload = require('js-file-download');

const client = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '/api/',
  json: true
});


class APIClient {

  getBackOfficeData(pageId, sorted, filters) {
    let params = {};
    if (sorted.length > 0 ){
      params['order_by'] = sorted[0].id;
      params['order_direction'] = sorted[0].desc ? "desc" : "asc";
    }
    if (filters) {
      params['filters'] = cloneDeep(filters);

      let startDate = filters['startDate'];
      if (startDate !== null) {
        // At 00:00, the conversion to ISO string resulted in -1 day!
        // certainly because of timezones (CEST vs UTC)
        // So we set an hour in the middle of the day
        startDate.setHours(10);
        params['filters']['startDate'] = startDate.toISOString();
      }
      let endDate = filters['endDate'];
      if (endDate !== null) {
        endDate.setHours(10);
        params['filters']['endDate'] = endDate.toISOString();
      }

    }
    return client.get('/backoffice/page/' + (pageId + 1), {params: params}).then(resp => {
        return resp.data
      }
    );
  }

  getBackOfficeCsvExport(sorted, filters){
    let params = {};
    if (sorted.length > 0 ){
      params['order_by'] = sorted[0].id;
      params['order_direction'] = sorted[0].desc ? "desc" : "asc";
    }
    if (filters) {
      params['filters'] = cloneDeep(filters);

      let startDate = filters['startDate'];
      if (startDate !== null) {
        // At 00:00, the conversion to ISO string resulted in -1 day!
        // certainly because of timezones (CEST vs UTC)
        // So we set an hour in the middle of the day
        startDate.setHours(10);
        params['filters']['startDate'] = startDate.toISOString();
      }
      let endDate = filters['endDate'];
      if (endDate !== null) {
        endDate.setHours(10);
        params['filters']['endDate'] = endDate.toISOString();
      }

    }
    return client.get('/backoffice/csv-export', {params: params}).then(resp => {
        FileDownload(resp.data, 'contributions.csv');
      }
    );
  }

  getBackOfficeContrib(id) {
    return client.get('/backoffice/' + id).then(resp => {
        return resp.data
      }
    );
  }

  moderate = async (id, moderate) => {
    let res = await client.patch('/backoffice/' + id, {moderated: moderate});
    return res;
  }

  moderateSeveral = async (ids, moderate) => {
    for (let id of ids) {
      await this.moderate(id, moderate);
    }
  }

  getBackOfficeParams() {
    return client.get('/backoffice/params/').then(resp => {
        return resp.data
      }
    );
  }

  setBackOfficeParam(id, value) {
    return client.patch('/backoffice/params/' + id, {[id]: value});
  }

  getBackOfficeHomeTestimonials = async () => {
    let res = await client.get('/backoffice/hometestimonials');
    return res.data;
  }

  updateBackOfficeHomeTestimonial = async (id, data) => {
    let res = await client.patch('/backoffice/hometestimonials/' + id, data);
    return res.data;
  }

}

export default APIClient;
